var map = {
	"./Gifcard_pacchetto_A.jpg": "fd41",
	"./Gifcard_pacchetto_B.jpg": "675b",
	"./Gifcard_pacchetto_C.jpg": "09d8",
	"./Gifcard_pacchetto_D.jpg": "0c77",
	"./ca_zampa_animale_1.jpg": "e70a",
	"./ca_zampa_animale_2.jpg": "348f",
	"./ca_zampa_animale_3.jpg": "3c56",
	"./ca_zampa_animale_4.jpg": "83b3",
	"./exante_assistenza_nucleo.jpg": "72ca",
	"./exante_assistenza_singolo.jpg": "74a7",
	"./exante_cura_nucleo.jpg": "948a",
	"./exante_cura_nucleo_no_massimale.jpg": "2a8c",
	"./exante_cura_singolo.jpg": "ee58",
	"./mobilita_sicura_nucleo.jpg": "5415",
	"./mobilita_sicura_singolo.jpg": "088b",
	"./odonto_cura_nucleo.jpg": "ddf5",
	"./odonto_cura_singolo.jpg": "22c0",
	"./odonto_emergenza_implantologia_nucleo.jpg": "083c",
	"./odonto_emergenza_implantologia_singolo.jpg": "1aff",
	"./odonto_emergenza_nucleo.jpg": "d412",
	"./odonto_emergenza_singolo.jpg": "43ef",
	"./pet_cura.jpg": "acfb",
	"./pet_salute.jpg": "a2f5",
	"./pet_salute_plus.jpg": "f94b",
	"./sezione_assistenza_sanitaria.jpg": "10c3",
	"./sezione_mobilita_sicura.jpg": "9635",
	"./sezione_odontoiatria.jpg": "7a41",
	"./sezione_pet.jpg": "feed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7595";